import { IconButton, styled } from '@material-ui/core';

export const VideoPlayerContainer = styled('div')(({ theme }) => ({
  borderRadius: 8,
  position: 'relative',
  overflow: 'hidden',
  width: '100%',
  height: 'auto',
  aspectRatio: '16/9',
}));

export const VideoPlayButtonContainer = styled(IconButton)(({ theme }) => ({
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  zIndex: 2,
}));

export const VideoPLayerDetailsContainer = styled('div')(({ theme }) => ({
  marginTop: 5,
  display: 'flex',
  width: '100%',
  position: 'absolute',
  gap: 5,
}));
